var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2363_51133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.503784 0.655762C0.226168 0.655762 -0.00162755 0.882937 0.0372661 1.15781C0.167629 2.07914 0.634865 2.94076 1.37339 3.60198C2.1253 4.27519 3.10578 4.69352 4.14962 4.79557C4.3296 4.81316 4.63248 4.49963 4.62745 4.31886C4.60505 3.51465 4.57959 1.94576 4.56733 1.14759C4.56314 0.874279 4.34044 0.655762 4.06709 0.655762H0.503784Z",
    fill: "#ABAAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5084 0.655762C19.786 0.655762 20.0138 0.882937 19.9749 1.15781C19.8446 2.07914 19.3773 2.94076 18.6388 3.60198C17.8869 4.27519 16.9064 4.69352 15.8626 4.79557C15.6826 4.81316 15.3797 4.49963 15.3848 4.31886C15.4072 3.51465 15.4326 1.94576 15.4449 1.14759C15.4491 0.874279 15.6718 0.655762 15.9451 0.655762H19.5084Z",
    fill: "#ABAAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8182 2.11676C17.8247 1.93023 17.828 1.83697 17.769 1.7759C17.71 1.71484 17.6148 1.71484 17.4242 1.71484H2.57564C2.38509 1.71484 2.28982 1.71484 2.23085 1.7759C2.17188 1.83697 2.17513 1.93023 2.18162 2.11676C2.34718 6.87136 4.98699 11.7634 8.45522 12.7222C8.61253 12.7657 8.69119 12.7874 8.73203 12.8411C8.77288 12.8948 8.77288 12.9715 8.77288 13.1251V16.2587C8.77288 16.404 8.77288 16.4766 8.73647 16.5284C8.70005 16.5802 8.62514 16.6071 8.4753 16.6609C7.33967 17.0688 6.4965 18.0901 6.34544 19.3254C6.3239 19.5015 6.31313 19.5896 6.37282 19.657C6.43252 19.7245 6.52875 19.7245 6.72121 19.7245H13.2786C13.471 19.7245 13.5673 19.7245 13.627 19.657C13.6867 19.5896 13.6759 19.5015 13.6543 19.3254C13.5032 18.0897 12.6596 17.0681 11.5234 16.6605C11.3735 16.6067 11.2986 16.5798 11.2621 16.528C11.2257 16.4763 11.2257 16.4036 11.2257 16.2583V13.1252C11.2257 12.9716 11.2257 12.8948 11.2665 12.8411C11.3074 12.7874 11.3861 12.7657 11.5434 12.7222C15.0128 11.7634 17.6527 6.87139 17.8182 2.11676Z",
    fill: "url(#paint0_linear_2363_51133)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81521 4.04502C9.88343 3.88052 10.1165 3.88052 10.1847 4.04502L10.8389 5.62232C10.8679 5.69224 10.9339 5.73979 11.0094 5.74519L12.7325 5.86824C12.9124 5.88108 12.9848 6.10668 12.8459 6.22173L11.531 7.31127C11.4717 7.36041 11.4459 7.43924 11.4646 7.51395L11.8772 9.15822C11.9207 9.33179 11.7319 9.47081 11.5791 9.37765L10.1041 8.47822C10.0401 8.43923 9.95976 8.43923 9.89582 8.47822L8.42082 9.37765C8.26803 9.47081 8.07916 9.33179 8.12271 9.15822L8.53527 7.51395C8.55401 7.43924 8.5282 7.36041 8.46889 7.31127L7.15398 6.22173C7.01513 6.10668 7.08747 5.88108 7.26734 5.86824L8.9905 5.74519C9.06601 5.73979 9.132 5.69224 9.161 5.62232L9.81521 4.04502Z",
    fill: "#ABAAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2363_51133",
    x1: 7.64736,
    y1: 31.9253,
    x2: 6.0029,
    y2: -29.0433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0926412,
    stopColor: "#CBC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730406,
    stopColor: "#ABAAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2363_51133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.8527d36ce68d030d8925cf813b17f928.svg";
export { ForwardRef as ReactComponent };